export default {
  name: 'c-loader',
  mounted() {
    // this.$store.commit('loader/preventScroll')
  },
  beforeDestroy() {
    // this.$store.commit('loader/allowScroll')
  }
}
